module.exports = __webpack_public_path__ + "static/media/dashboardIcon.7f9c5ed8.svg";